import React from 'react';
import { Sparkles } from 'lucide-react';

interface ExampleQuestionCardProps {
  icon?: React.ReactNode;
  question: string;
  onClick: () => void;
}

const ExampleQuestionCard: React.FC<ExampleQuestionCardProps> = ({
  icon = <Sparkles size={16} className='text-gray-400' />,
  question,
  onClick,
}) => {
  return (
    <button
      type='button'
      onClick={onClick}
      className='w-full bg-white/60 backdrop-blur-sm border border-gray-200/60 rounded-lg p-3 sm:p-4 hover:bg-white hover:border-[#1551DD]/30 hover:shadow-sm transition-all duration-200 text-left group'
    >
      <div className='flex items-start gap-2.5 sm:gap-3'>
        <div className='flex-shrink-0 mt-0.5 group-hover:scale-110 transition-transform duration-200 opacity-60 group-hover:opacity-100'>
          {icon}
        </div>
        <span className='text-xs sm:text-sm text-gray-600 group-hover:text-[#1551DD] leading-snug'>
          {question}
        </span>
      </div>
    </button>
  );
};

export default ExampleQuestionCard;
